/**
 * The sample's friction surveys and model figures, in the platform's shapes.
 *
 * Empty on purpose. The boards seed the August survey and the two provisional
 * removals themselves, and the sample's boards never read these back (the
 * feed runs on the platform only), so returning them here would show the
 * same survey twice the day anything did. What the sample keeps is what a
 * person enters during the visit — and the platform's answers to it: a
 * reference, a refusal, "already held".
 */
import type { FrictionSurvey } from "../domain/friction";

/** The lines a survey can be loaded against, as the platform holds them at Madinah. */
export const MOCK_REFERENCES: Record<string, { lengthM: number; forward: string }> = {
  "RWY-17-35": { lengthM: 4333.037, forward: "17" },
  "RWY-18-36": { lengthM: 3048.974, forward: "18" },
};

/** The models a site may hold its own figures for. */
export const MOCK_MODELS = new Set([
  "lamp_survival",
  "pci_degradation",
  "rotating_plant_health",
  "marking_wear",
  "peer_outlier",
  "contaminant_accumulation",
]);

export const mockFrictionSurveys = (): FrictionSurvey[] => [];
